type Option = { label: string; value: string };

export interface PromoConfigApiResponse {
    promotion_types: {
        key: string;
        display_name: string;
    }[];
}

export interface ParsedPromoOptions {
    promoTypeOptions: Option[];
}

export function parsePromoConfigResponse(config: PromoConfigApiResponse): ParsedPromoOptions {
    const promoTypeOptions = config.promotion_types.map((pt) => ({
        label: pt.display_name,
        value: pt.key,
    }));

    return { promoTypeOptions };
}
